/**
 * @generated SignedSource<<099e502bcf6fca54cf0d59cdb89df1cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "TradeOnboardingCoachmarkConditionalLoader_user";
};
export type TradeOnboardingCoachmarkConditionalLoader_user$key = {
  readonly " $data"?: TradeOnboardingCoachmarkConditionalLoader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeOnboardingCoachmarkConditionalLoader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeOnboardingCoachmarkConditionalLoader_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f94bcabbf168345679c1f91512d4e4ae";

export default node;
